<template>
  <div
    class="spnod-admin__form--container container mx-0 w-100 h-100"
    :class="isMobile ? 'px-0' : 'px-3'">
    <b-form @submit.stop.prevent="handleSubmit">
      <b-form-group class="mb-4">
        <b-form-input
          name="username"
          v-model="$v.form.username.$model"
          :state="validateState('username')"
          type="text"
          placeholder="Email"
          size="sm"
          class="mb-2"
        ></b-form-input>
        <b-input-group class="mb-2">
          <b-form-input
            name="password"
            v-model="$v.form.password.$model"
            :state="validateState('password')"
            :type="isPasswordDisplayed"
            placeholder="Password"
            size="sm"
            class="mb-0"
          >
          </b-form-input>
          <b-input-group-append>
            <span class="input-group-text small spnod-cursor" @click="handlePassToggle('password')">
              <i v-if="!showPassword" class="fa fa-eye fa-sm"></i>
              <i v-else class="fa fa-eye-slash fa-sm"></i>
            </span>
          </b-input-group-append>
        </b-input-group>
        <ul class="spnod-admin__form--list">
          <li>
            <router-link id="signup" class="spnod-admin__form--link" to="/signup">Sign Up</router-link>
          </li>
          <li>
            <router-link id="forgot-password" class="spnod-admin__form--link" to="/forgot-password">Forgot Password</router-link>
          </li>
        </ul>
      </b-form-group>
      <b-form-group class="d-flex justify-content-end">
        <b-button class="spnod-admin__form--button" type="submit" size="sm" :disabled="isDisabled">
          <p v-if="!isSending">Login</p>
          <span v-else class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        </b-button>
      </b-form-group>
    </b-form>
    <div class="d-flex align-items-center flex-column">
      <a
        class="spnod-admin__form--link mb-1 text-muted"
        href="https://app.termly.io/document/terms-of-use-for-website/6a339b70-c0f6-46e7-ae47-1bb78046b8b9"
        target="_blank">
        Terms of Service
      </a>
      <a
        class="spnod-admin__form--link text-muted"
        href="mailto:support@spnod.com">
        Contact us
      </a>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { required, email } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'

export default {
  name: 'LoginForm',
  mixin: [validationMixin],
  data() {
    return {
      form: {
        username: '',
        password: ''
      },
      showPassword: false,
      isSending: false
    }
  },
  computed: {
    ...mapGetters(['loggedIn', 'getMyInfo']),
    isDisabled() {
      const anyBlanks = Object.entries(this.form).some((k, v) => v === '')
      return anyBlanks || this.$v.form.$anyError
    },
    isPasswordDisplayed() {
      return this.showPassword ? 'text' : 'password'
    },
    isMobile() { return window.innerWidth <= 768 }
  },
  methods: {
    ...mapActions(['doLogin', 'getMe']),
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    handleSubmit: async function (e) {
      this.$v.form.$touch()

      if (this.$v.form.$anyError) {
        return
      }
      this.isSending = true
      await this.doLogin(this.form)
      this.isSending = false
    },
    handlePassToggle() {
      this.showPassword = !this.showPassword
    }
  },
  validations: {
    form: {
      username: { required, email },
      password: { required }
    }
  },
  watch: {
    loggedIn: async function (newVal, oldVal) {
      await this.getMe()
      if (this.getMyInfo.isClient) {
        this.$router.push('/messages')
      } else {
        this.$router.push('/user')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/components/Forms/LoginForm.vue?93bd3560